export default {
  title: 'Components/Tabs',
  tags: ['autodocs'],
  argTypes: {
    type: {
      control: { type: 'select' },
      options: ['text', 'text-icon'],
      description: 'Type of the tabs',
    },
    hover_style: {
      control: { type: 'select' },
      options: ['dda-tab-default', 'dda-tab-filed', 'dda-tab-underline', 'dda-tab-underline-filled'],
      description: 'Hover style of the tabs',
    },
    custom_class: {
      control: { type: 'text' },
      description: 'Custom class for the tabs',
    },
    component_mode: {
      control: { type: 'check' },
      options: ['light-mode'],
      description: 'Mode of the tabs component',
    },
    button_ids: {
      control: { type: 'array' },
      description: 'Array of Button IDs for accessibility',
    },
    button_values: {
      control: { type: 'array' },
      description: 'Array of values for each tab button',
    },

    tab_texts: {
      control: { type: 'array' },
      description: 'Array of tab labels',
    },
    tab_type: {
      control: { type: 'select' },
      options: ['dda-horizontal-tab', 'dda-vertical-tab'],
    },
    onTabClick: {
      action: 'tab-clicked',
      description: 'Callback function when a tab is clicked',
    },
    button_name: { 
      control: { type: 'text' },
      description: 'Button name for the tabs',
    }
  },
  parameters: {
    docs: {
      description: {
        component: `
  To use the \`dda-tabs\` component, pass the following props:

  \`\`\`html
    <dda-tabs
      type="text"
      hover_style="dda-tab-default"
      custom_class=""
      component_mode=""
      button_ids='["tab-btn-1", "tab-btn-2", "tab-btn-3"]'
      tab_texts='["Tab 1", "Tab 2", "Tab 3"]'
      tab_type='dda-horizontal-tab'
      onTabClick="handleTabClick"
      button_name="button"
    ></dda-tabs>

    <script>
      function handleTabClick(index) {
        console.log('Clicked Tab:', index);
      }
    </script>
  \`\`\`
  `,
      },
    },
  },
};

const Template = (args) => {
  const attributes = Object.entries(args)
    .filter(([key, value]) => value !== undefined && key !== 'text')
    .map(([key, value]) =>
      Array.isArray(value) ? `${key}='${JSON.stringify(value)}'` : `${key}="${value}"`
    )
    .join(' ');

  return `<dda-tabs ${attributes}></dda-tabs>`;
};


export const TextTabs = Template.bind({});
TextTabs.args = {
  type: 'text',
  hover_style: 'dda-tab-default',
  custom_class: '',
  component_mode: '',
  button_ids: ['tab-btn-1', 'tab-btn-2', 'tab-btn-3'],
  button_values: ["val-1", "val-2", "val-3"],
  tab_texts: ['Tab 1', 'Tab 2', 'Tab 3'],
  tab_type: 'dda-horizontal-tab',
  button_name: 'button',
  onTabClick: (index) => alert(`Tab ${index + 1} clicked!`), // Example event
};

export const TextIconTabs = Template.bind({});
TextIconTabs.args = {
  type: 'text-icon',
  hover_style: 'dda-tab-default',
  custom_class: '',
  component_mode: '',
  button_ids: ['tab-btn-1', 'tab-btn-2', 'tab-btn-3'],
  button_values: ["val-1", "val-2", "val-3"],
  tab_texts: ['Tab 1', 'Tab 2', 'Tab 3'],
  tab_type: 'dda-horizontal-tab',
  button_name: 'button',
  onTabClick: (index) => alert(`Tab ${index + 1} clicked!`), // Example event
};
